import { ADD_FUNCTIONS } from './types'

export function setFunctionData(data: any) {
  return {
    type: ADD_FUNCTIONS,
    data,
  }
}
